
// Deprecated see ProjectAccess - maybe rename later as Goal Access ?
export enum Access {
    READ_ONLY   = -10,
    // READ_ONLY_WITH_COMMENT= -9, // just reserve
    CLIENT      = -5,

    LIMITED     = 1,
    STANDARD    = 2,
    FULL        = 3,
}
